import React from 'react';
import styled from 'styled-components';

import { BasicCard } from '@src/components/recommendedPlanCard/course';
import useCurrentCourse from '@src/hooks/useCurrentCourse';

const HEIGHT_NAVIGATION = 58;

const FixedWrapper = styled.div`
	${({ isFixed, bottomOffset }: {
		isFixed: boolean;
		bottomOffset: number;
	}) => {
		const isReachBottom = bottomOffset <= 0;

		return (isFixed ? `
		position: fixed;
		top: ${HEIGHT_NAVIGATION}px;
		height: calc(100vh - ${isReachBottom ? HEIGHT_NAVIGATION + 150 : HEIGHT_NAVIGATION}px);
	` : `
		position: relative;
	`);
	}}

	width: 340px;
	@media ${props => props.theme.device.tablet} {
		width: 256px;
	}
	overflow: auto;
`;

const CardsWrapper = styled.div`
	width: 100%;
	padding: 20px 8px;
	box-sizing: border-box;
`;

interface IProps {
	isFixed: boolean;
	bottomOffset: number;
}

const RecommendedPlanCards = ({ isFixed, bottomOffset }: IProps): JSX.Element => {
	const { currentCourse } = useCurrentCourse();

	return (
		<FixedWrapper isFixed={isFixed} bottomOffset={bottomOffset}>
			<CardsWrapper>
				<BasicCard course={currentCourse} />
			</CardsWrapper>
		</FixedWrapper>
	);
};

export default RecommendedPlanCards;
